import { __assign } from "tslib";
import clsx from 'clsx';
import React from 'react';
import Icon from '../../icon/internal';
import styles from './styles.css.js';
import useFocusVisible from '../../internal/hooks/focus-visible';
export var CircularButton = React.forwardRef(function (_a, ref) {
    var style = _a.style, className = _a.className, ariaLabel = _a.ariaLabel, ariaExpanded = _a.ariaExpanded, iconName = _a.iconName, disabled = _a.disabled, side = _a.side, fixed = _a.fixed, onClick = _a.onClick;
    var focusVisible = useFocusVisible();
    return (React.createElement("button", __assign({}, focusVisible, { style: style, ref: ref, disabled: disabled, className: clsx(styles['circular-toggle'], styles["circular-toggle-side-" + side], fixed && styles['circular-toggle-fixed'], className), "aria-label": ariaLabel, "aria-expanded": ariaExpanded, onClick: onClick }),
        React.createElement(Icon, { name: iconName })));
});
//# sourceMappingURL=circular-button.js.map